import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Result } from '../../domain';
import { AdHocCommitteeInfo, ReviewerCommitteeMember } from '../../domain/data-access-interfaces';
import { SelectUserModalComponent } from '../select-user-modal/select-user-modal.component';

// Committee-editing helpers shared by the Committees admin page and the case
// modal's review-steps editor.

/** Open the person picker; run `then` only when someone was chosen. `excludeIds`
 *  hides people already on the committee — the server rejects duplicates anyway,
 *  so this is to keep the list short rather than to enforce anything. */
export function pickPerson(dialog: MatDialog, then: (userId: number) => void, excludeIds: number[] = [], title?: string): void {
	SelectUserModalComponent.open(dialog, { excludeIds, title }).subscribe(userId => {
		if (userId) then(userId);
	});
}

/** Run `onSuccess` when the operation succeeds, snack the error otherwise. */
export function applyResult(op: Promise<Result<void, string>>, snackbar: MatSnackBar, onSuccess: () => void): void {
	op.then(result => result.matchDo(
		onSuccess,
		errorMsg => snackbar.open(errorMsg, undefined, { duration: 5000 })
	));
}

/** The chair, or null for a committee that has none yet. The server sorts
 *  members writer-first, so the chair is the first flagged member. */
export function adHocChair(c: AdHocCommitteeInfo): ReviewerCommitteeMember | null {
	return c.members.find(m => m.writesReview) || null;
}

/** Identifies a committee in the assign dropdown, where there's no room for
 *  a second line: "Committee 7 (Christopher Hanson)". */
export function adHocCommitteeLabel(c: AdHocCommitteeInfo): string {
	const chair = adHocChair(c);
	return `Committee ${c.committeeId} (${chair ? chair.name : 'no chair'})`;
}
